import {IStore} from "../../../app/store";
import CourtEntity from "../../../courts/entities/court.entity";

export default class MapRepository {
  private readonly store: IStore

  constructor (store: IStore) {
    this.store = store
  }

  setLocation (lat: number, lng: number) {
    this.store.map.lat = lat
    this.store.map.lng = lng
  }

  getLocation (): {lat: number, lng: number} {
    return {
      lat: this.store.map.lat,
      lng: this.store.map.lng
    }
  }

  getSearchTerm (): string {
    return this.store.map.searchTerm
  }

  setCourts (courts: CourtEntity[]) {
    this.store.map.courts = courts
  }

  getCourts (): CourtEntity[] {
    return this.store.map.courts
  }

  selectCourt (court: CourtEntity) {
    this.store.map.selectedCourt = court
  }

  getSingleCourt (courtId: string): CourtEntity | undefined {
    return this.store.map.singleCourts.get(courtId)
  }

  setSingleCourt (courtId: string, court: CourtEntity) {
    this.store.map.singleCourts.set(courtId, court)
  }

  getSelectedCourt (): CourtEntity {
    return this.store.map.selectedCourt
  }

  showPopup (isVisible: boolean) {
    this.store.map.showCourtPopup = isVisible
  }

  getShowPopup (): boolean {
    return this.store.map.showCourtPopup
  }
}
